import { Grid } from '@material-ui/core';
import styled from 'styled-components';

export const StyledGrid = styled(Grid)`
  height: 80px;
  margin-top: ${({ mt }) => mt || 0}px;
`;
